<template>
  <tr class="hierarchy__row hierarchy__row--group-headers">
    <th class="border-right">
      <span class="d-inline-flex align-center">
        <span v-if="isGridViewLoading">
          <v-icon class="fa-spin" color="pimary">autorenew</v-icon>
          <span>{{ $t('gridView.tooltips.loading') }}</span>
        </span>
      </span>
    </th>
    <th colspan="4" class="border-right">{{ $t('gridView.salesMetrics') }}</th>
    <th colspan="3" class="border-right">
      {{ $t('gridView.margin') }}
    </th>
    <th
      v-for="(competitorIndex, index) in selectedCompetitors.length"
      :key="competitorIndex"
      :colspan="competitorColumnsPerGroup"
      class="border-right"
    >
      <v-row align="center" dense no-gutters>
        <div
          v-if="!isAgGridProductListEnabled || (isAgGridProductListEnabled && index === 0)"
          class="pr-1"
        >
          {{ $t('gridView.priceDistance') }}
        </div>
        <div v-else>&nbsp;</div>

        <div v-if="isAgGridProductListEnabled && index === 0">
          <competitors-selector />
        </div>
      </v-row>

      <v-row v-if="isAgGridProductListEnabled" class="mt-2" dense no-gutters>
        {{ selectedCompetitors[competitorIndex - 1].competitorDisplayDescription }}
      </v-row>
      <v-row v-else dense no-gutters>
        <competitor-filter
          :disabled="isGridViewLoading"
          :selected-competitor="selectedCompetitors[competitorIndex - 1]"
          @selectCompetitor="selectCompetitor($event, competitorIndex - 1)"
        />
      </v-row>
    </th>
    <th class="border-right">{{ $t('gridView.tension') }}</th>
    <th>{{ $t('gridView.changes') }}</th>
    <th v-if="!isAgGridProductListEnabled" />
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { showUnsimulatedIndex } from '@enums/feature-flags';

export default {
  computed: {
    ...mapState('gridView', ['selectedCompetitors']),
    ...mapState('clientConfig', ['toggleLogic']),
    ...mapState('filters', ['retailAttributesFilter']),
    ...mapGetters('gridView', ['isAgGridProductListEnabled', 'isGridViewLoading']),

    numFiltersApplied() {
      return this.retailAttributesFilter.length;
    },

    competitorColumnsPerGroup() {
      const showUnsimulatedColumn = this.toggleLogic[showUnsimulatedIndex];
      return showUnsimulatedColumn ? 6 : 4;
    },
  },

  methods: {
    ...mapActions('gridView', ['setSelectedCompetitorAtIndex']),

    selectCompetitor(selectedCompetitor, index) {
      this.setSelectedCompetitorAtIndex({ selectedCompetitor, index });
      this.globalEmit('competitor-selection-changed');
    },
  },
};
</script>

<style lang="scss" scoped>
.hierarchy__row--headers > td {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 1.2rem;
  font-weight: 700;
}

th {
  font-size: 1rem;
  font-weight: 600;
}
</style>
